import React from 'react';

export const Forbidden = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 16 17" fill="none">
    <circle cx="8" cy="8.83447" r="5.5" stroke={color} />
    <path d="M12 12.8345L4 4.83447" stroke={color} />
  </svg>
);
